'use client'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

export function Break({
  xs = true,
  sm = xs,
  md = sm,
  lg = md,
  xl = lg,
  condition = false,
  sticky = true,
  filler = '',
}) {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.up('sm'))
  const isMd = useMediaQuery(theme.breakpoints.up('md'))
  const isLg = useMediaQuery(theme.breakpoints.up('lg'))
  const isXl = useMediaQuery(theme.breakpoints.up('xl'))

  let shouldRender = xs
  if (isSm) shouldRender = sm
  if (isMd) shouldRender = md
  if (isLg) shouldRender = lg
  if (isXl) shouldRender = xl
  if (condition) shouldRender = condition
  if (shouldRender) return <br />
  return sticky ? <>&nbsp;</> : <>{filler}</>
}

export default Break
